<template>
    <div class="previous-step__container">
        <router-link :to="goToStep" class="previous-step__link" :class="{ 'previous-step__link--hidden': hidden === true }">{{ linkText }}</router-link>
    </div>
</template>

<script>
export default {
    props: {
        goToStep: {
            required: true,
        },
        linkText: {
            type: String,
            required: false,
            default: "Back a step",
        },
        hidden: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.previous-step {
    &__container {
        margin-top: 30px;
        display: flex;
        align-items: center;

        @media (max-width: 767px) {
            justify-content: center;
        }
    }

    &__link {
        font-family: "Encode Sans", sans-serif;
        font-size: 16px;
        font-weight: 700;
        color: #0293d6;

        &:hover {
            cursor: pointer;
        }

        &::before {
            display: inline-block;
            content: url("/images/link-icon.svg");
            width: 20px;
            height: 20px;
            transform-origin: center;
            transform: rotate(183deg) translateY(-5px);
            margin-right: 10px;
        }

        &--hidden {
            visibility: hidden;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/test-drive/components/Navigation.vue